import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api/authAPI';
import { Container, Form, Button, Row, Col, Alert, Card } from 'react-bootstrap';
import TwoFactorVerification from '../components/TwoFactorVerification';

function LoginScreen() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [show2FA, setShow2FA] = useState(false);
  const [pendingUsername, setPendingUsername] = useState('');
  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await authAPI.login({
        username,
        password,
      });
      
      if (data && data.needs2FA) {
        // User needs 2FA verification
        setPendingUsername(username);
        setShow2FA(true);
      } else if (data && data.access) {
        // Login successful without 2FA
        console.log('Login successful:', data);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data?.error || 'Login failed');
    }
  };

  const handle2FASuccess = async () => {
    setShow2FA(false);
    try {
      // Complete the login process by calling login_step2
      const data = await authAPI.loginStep2(pendingUsername, '');
      if (data && data.access) {
        console.log('2FA login successful:', data);
        navigate('/dashboard');
      } else {
        setError('Login failed after 2FA verification');
      }
    } catch (err) {
      setError('Login failed after 2FA verification: ' + (err.response?.data?.error || err.message));
    }
  };

  const handle2FACancel = () => {
    setShow2FA(false);
    setPendingUsername('');
  };

  return (
    <Container 
      fluid 
      className="min-vh-100" 
      style={{ 
        backgroundColor: '#122a5a',
        //backgroundImage: 'url(/secondary_white.png)',
        //backgroundRepeat: 'no-repeat',
        //backgroundPosition: 'left',
        //backgroundSize: '20%',
        //backgroundBlendMode: 'soft-light',
      }}
    >
      <Row className="justify-content-md-center align-items-center min-vh-100">
        <Col xs={12} md={5} lg={4}>
          <div className="bg-white p-4 rounded-3 shadow-lg">
            <img 
              src="/logo_blue.png" 
              alt="Liberty Trade Corporation" 
              className="img-fluid mb-4 mx-auto d-block"
              style={{ maxHeight: '100px' }}
            />
            <hr className="my-4" style={{ borderColor: '#122a5a' }} />

            {error && <div className="alert alert-danger">{error}</div>}
            
            <Form onSubmit={submitHandler}>
              <Form.Group className="mb-3" controlId="username">
                <Form.Label style={{ color: '#122a5a', fontWeight: '500' }}>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="border-2"
                  style={{ borderColor: '#122a5a' }}
                    autoComplete="off"
                    spellCheck="false"
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="password">
                <Form.Label style={{ color: '#122a5a', fontWeight: '500' }}>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="border-2"
                  style={{ borderColor: '#122a5a' }}
                    autoComplete="off"
                    spellCheck="false"
                />
              </Form.Group>

              <div className="d-grid">
                <Button 
                  variant="primary" 
                  type="submit"
                  size="lg"
                  style={{ 
                    backgroundColor: '#122a5a', 
                    borderColor: '#122a5a',
                    padding: '0.8rem'
                  }}
                  className="text-white fw-bold"
                >
                  Sign In
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
      
      {/* 2FA Verification Modal */}
      <TwoFactorVerification
        show={show2FA}
        username={pendingUsername}
        onSuccess={handle2FASuccess}
        onCancel={handle2FACancel}
      />
    </Container>
  );
}

export default LoginScreen;